import { TimepointExamReassignmentPreviewResponse, TimepointSubmissionStatus } from '@common/config/api/client'
import { East } from '@mui/icons-material'
import { Stack, TableBody, TableCell, TableRow, Typography } from '@mui/material'

export default function ReassignExamTimepointTableBody({
  timepoint,
  timepointStatus,
}: {
  timepoint: TimepointExamReassignmentPreviewResponse
  timepointStatus: TimepointSubmissionStatus | ''
}) {
  const formatStatus = (status: string) => {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replace(/_/g, ' ')
  }

  return (
    <TableBody>
      <TableRow>
        <TableCell>
          <Typography color="text.primary" variant="body2">
            {timepoint.timepoint_submission_name}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography color="text.primary" variant="body2">
            {formatStatus(timepoint.timepoint_submission_status)}
          </Typography>
        </TableCell>
        <TableCell>
          <Stack>
            <East />
          </Stack>
        </TableCell>
        <TableCell>
          <Typography color="text.primary" variant="body2">
            {formatStatus(timepointStatus)}
          </Typography>
        </TableCell>
      </TableRow>
    </TableBody>
  )
}
